import { createArray } from 'helpers';
import * as setup from 'setup';
import Ant from './Ant';

export default class AntQueen extends Ant {

    constructor(gameState: GameState, props?: AntProps, state?: any) {
        super(gameState, 'queen', setup.ants.queen, {
            ...props,
            movingTextures: createArray(10, i => `ant/queen/ant-queen-moving-${i + 1}.png`),
        }, state);
        
        // Initialize
        this.zIndex = 10;
    }

    init = () => {
        this.onMove();
        this.moveToParadise();
    }

}